// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__ZGaqU","noColumns":"Switch_noColumns__0eT3f","label":"Switch_label__fkd5u","checked":"Switch_checked__tQBga"};